export default __webpack_public_path__ + "static/media/create-review-header.b59f8556.svg";